import {CreateBundleFormValues} from "../reducers/create-bundle/types";
import {CreateSessionData} from "../../../../features/sessions";
import {createSessionDto} from "../../createService/create-service-service";

export function createBundleV2Dto(values: CreateBundleFormValues): CreateSessionData {
  return {
    ...createSessionDto(values),
    noOfSessions: Number(values.numberOfSessions),
    bookingInterval: values.bookingInterval,
  };
}
